module.exports = __webpack_public_path__ + "img/box.84520b12.svg";